import { render } from "./Routedetails.vue?vue&type=template&id=6bd9f3b7"
import script from "./Routedetails.vue?vue&type=script&lang=js"
export * from "./Routedetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__